// extracted by mini-css-extract-plugin
module.exports = {"root":"TabsNav_root__2F5Oo","tab":"TabsNav_tab__2pTfT","active":"TabsNav_active__2VAzi"};